import Typography from '@ui/typography'
import cn from '@ui/utils/cn'
import { useState } from 'react'
import { Pressable, View } from 'react-native'
import { Collapsible } from '@ui/animated/Collapsible'

export default function CollapsibleSection({
  header,
  children,
  contentClassName,
  open,
  defaultOpen = false,
  onToggle,
}: {
  header: React.ReactNode
  children: React.ReactNode
  contentClassName?: string
  open?: boolean
  defaultOpen?: boolean
  onToggle?: () => void
}) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen)
  const isOpen = open ?? internalOpen
  const handleToggle = () => {
    onToggle?.()
    if (open === undefined) {
      setInternalOpen((value) => !value)
    }
  }

  return (
    <View className="overflow-hidden rounded-md border border-black/20">
      <Pressable
        onPress={handleToggle}
        className={cn(
          'flex-row items-center gap-2 p-4 opacity-60 hover:bg-black/5 hover:opacity-100',
          isOpen && 'bg-black/5 opacity-100'
        )}
      >
        <Typography variant="XSB" className="opacity-40">
          {isOpen ? '▾' : '▸'}
        </Typography>
        {header}
      </Pressable>
      <Collapsible open={isOpen} fullWidth>
        <View className={cn('gap-3 py-4', contentClassName)}>{children}</View>
      </Collapsible>
    </View>
  )
}
